export default {
  vanDatetimePicker: {
    confirm: "ยืนยัน",
    cancel: "ยกเลิก",
  },
  name: "ชื่อ",
  tel: "โทรศัพท์",
  save: "บันทึก",
  confirm: "ยืนยัน",
  cancel: "ยกเลิก",
  delete: "ลบ",
  complete: "เสร็จสิ้น",
  loading: "กำลังโหลด...",
  telEmpty: "กรุณากรอกหมายเลขโทรศัพท์",
  nameEmpty: "กรุณากรอกชื่อ",
  nameInvalid: "รูปแบบชื่อไม่ถูกต้อง",
  confirmDelete: "คุณแน่ใจหรือไม่ว่าต้องการลบ?",
  telInvalid: "รูปแบบหมายเลขโทรศัพท์ไม่ถูกต้อง",
  SelectYearMonthDay: "เลือกปี เดือน วัน",
  vanCalendar: {
    end: "สิ้นสุด",
    start: "เริ่มต้น",
    title: "ปฏิทิน",
    confirm: "ยืนยัน",
    startEnd: "เริ่มต้น/สิ้นสุด",
    weekdays: ["อา.", "จ.", "อ.", "พ.", "พฤ.", "ศ.", "ส."],
    monthTitle: (year, month) => `${year}/${month}`,
    rangePrompt: (maxRange) => `เลือกได้ไม่เกิน ${maxRange} วัน`,
  },
  vanCascader: {
    select: "เลือก",
  },
  vanContactCard: {
    addText: "เพิ่มข้อมูลติดต่อ",
  },
  vanContactList: {
    addText: "เพิ่มผู้ติดต่อใหม่",
  },
  vanPagination: {
    prev: "ก่อนหน้า",
    next: "ถัดไป",
  },
  vanPullRefresh: {
    pulling: "ดึงลงเพื่อรีเฟรช...",
    loosing: "ปล่อยเพื่อรีเฟรช...",
  },
  vanSubmitBar: {
    label: "รวม:",
  },
  vanCoupon: {
    unlimited: "ไม่จำกัด",
    discount: (discount) => `ส่วนลด ${discount * 10}%`,
    condition: (condition) => `ขั้นต่ำ ${condition}`,
  },
  vanCouponCell: {
    title: "คูปอง",
    tips: "ไม่มีคูปอง",
    count: (count) => `คุณมี ${count} คูปอง`,
  },
  vanCouponList: {
    empty: "ไม่มีคูปอง",
    exchange: "แลกเปลี่ยน",
    close: "ปิด",
    enable: "ใช้ได้",
    disabled: "ใช้ไม่ได้",
    placeholder: "รหัสคูปอง",
  },
  vanAddressEdit: {
    area: "พื้นที่",
    postal: "รหัสไปรษณีย์",
    areaEmpty: "กรุณาเลือกพื้นที่รับ",
    addressEmpty: "ที่อยู่ไม่สามารถเว้นว่างได้",
    postalEmpty: "รหัสไปรษณีย์ไม่ถูกต้อง",
    defaultAddress: "ตั้งเป็นที่อยู่หลัก",
    telPlaceholder: "โทรศัพท์",
    namePlaceholder: "ชื่อ",
    areaPlaceholder: "พื้นที่",
  },
  vanAddressEditDetail: {
    label: "ที่อยู่",
    placeholder: "ที่อยู่",
  },
  vanAddressList: {
    add: "เพิ่มที่อยู่ใหม่",
  },
  realName: "ชื่อจริง",
  idCard: "บัตรประชาชน",

  unionManagement: {
    GuildRegistration: "ลงทะเบียนกิลด์",
    GuildSettlementWelcomeLine1: "ยินดีต้อนรับสู่",
    GuildSettlementWelcomeLine2: "Rain Chat guild",
    GuildSettlementFormBanner: "กรุณากรอกข้อมูลการเข้าร่วมกิลด์",
    ApplicantID: "รหัสผู้สมัคร",
    GuildName: "ชื่อกิลด์",
    PleaseGuildName: "กรุณากรอกชื่อกิลด์",
    PleaseGuildID: "กรุณากรอกรหัสกิลด์",
    PleaseInformation: "กรุณากรอกข้อมูลติดต่อของคุณ",
    PlatformsWith: "แพลตฟอร์มที่เคยร่วมงาน",
    ListOfplatforms: "ระบุแพลตฟอร์มที่เคยร่วมงาน",
    GuildSize: "ขนาดกิลด์",
    EstimatedNumber: "จำนวนผู้ดำเนินรายการโดยประมาณ",
    Notes: "หมายเหตุ: ติดต่อหัวหน้ากิลด์หรือสมาชิกกิลด์เพื่อรับรหัสกิลด์",
    Submit: "ส่ง",
    SubmitSuccess: "ส่งสำเร็จ",
    MyGuild: "กิลด์ของฉัน",
    VoiceHallOnboarding: "ลงทะเบียนห้องเสียง",
    WelcomeRainChatVoice: "Welcome to Rain Chat Voice",
    VoiceHallJoinFormBanner: "กรุณากรอกข้อมูลการเข้าร่วมห้อง",
    VoiceHallName: "ชื่อกิลด์เสียง",
    PleaseVoiceHallName: "กรุณากรอกชื่อกิลด์เสียง",
    VoiceHallRealName: "ชื่อจริง",
    PleaseVoiceHallRealName: "กรุณากรอกชื่อจริงของคุณ",
    WhatsApp: "WhatsApp",
    PleaseContactInfo: "กรุณากรอกข้อมูลติดต่อของคุณ",
    PlatformsCollaborated: "แพลตฟอร์มที่เคยร่วมงาน",
    ListPlatformsCollaborated: "ระบุแพลตฟอร์มที่เคยร่วมงาน",
    VoiceHallScale: "ขนาดกิลด์เสียง",
    EstimatedAnchors: "จำนวนผู้ดำเนินรายการห้องเสียงโดยประมาณ",
    CertificationType: "ประเภทการรับรอง",
    VoiceHall: "ห้องเสียง",
    VoiceGuild: "กิลด์เสียง",
    HostName: "ชื่อผู้ดำเนินรายการ",
    GuildJoinDate: "วันที่เข้าร่วมกิลด์",
    TotalMembers: "จำนวนสมาชิกกิลด์ทั้งหมด",
    TotalPeople: "จำนวนคนทั้งหมด",
    RoomNicknameLabel: "ชื่อเล่นห้อง",
    DataDetails: "รายละเอียดข้อมูล",
    PleaseHostID: "กรุณากรอกรหัสผู้ดำเนินรายการ",
    Search: "ค้นหา",
    KickOut: "ไล่ออก",
    NoData: "ไม่มีข้อมูล",

    InformationData: "ข้อมูล",
    Name: "ชื่อ",
    PleaseID: "กรุณาตรงกับชื่อบนบัตรประชาชน",
    IdentityCard: "บัตรประชาชน",
    YourIDnumber: "หมายเลขบัตรประชาชนของคุณ",
    IDPhoto: "รูปบัตรประชาชน",
    PleasePhoto: "กรุณาอัปโหลดรูปบัตรประชาชน",
    FrontofID: "ด้านหน้าบัตร",
    BackofID: "ด้านหลังบัตร",
    NotePlease:
      "หมายเหตุ: กรุณาอัปโหลดรูปคุณถือบัตร ใบหน้าต้องชัดไม่มีสิ่งบัง รูปบัตรและหมายเลขต้องอ่านได้",
    Country: "ประเทศ",
    SelectCountryorRegion: "เลือกประเทศ/ภูมิภาค",
    BankName: "ชื่อธนาคาร",
    Pleasebankname: "กรุณากรอกชื่อธนาคารที่เปิดบัญชี",
    BankCardNumber: "หมายเลขบัญชี",
    Pleasebankcardnumber: "กรุณากรอกหมายเลขบัตรธนาคาร",
    BankCardHolder: "ชื่อผู้ถือบัตร",
    Pleasebankcardholder: "กรุณากรอกชื่อผู้ถือบัตรธนาคาร",
    PhoneNumber: "หมายเลขโทรศัพท์",
    Enterphonenumber: "กรุณากรอกหมายเลขโทรศัพท์ที่ถูกต้อง",
    Notebankaccount: "หมายเหตุ: กรุณากรอกหมายเลขโทรศัพท์ที่ลงทะเบียนกับธนาคาร",
    WhatsAppContactInformation: "ข้อมูลติดต่อ WhatsApp",
    Pleaseownnumber: "กรุณากรอกหมายเลขของตัวคุณเอง",
    Notecollaborationmatters:
      "หมายเหตุ: ข้อมูล WhatsApp ที่กิลด์กรอกจะถือเป็นช่องทางติดต่อเรื่องความร่วมมือเพียงอย่างเดียว",
    Email: "อีเมล",
    Pleaseemailaddress: "กรุณากรอกอีเมลของตัวคุณเอง",
    Notematters:
      "หมายเหตุ: อีเมลที่กิลด์กรอกจะถือเป็นช่องทางติดต่อเรื่องความร่วมมือเพียงอย่างเดียว",
    BasicInformationSection: "ข้อมูลพื้นฐาน",
    RemarksInformationSection: "ข้อมูลเพิ่มเติม",

    SpecialGiftDetails: "รายละเอียดของขวัญเอฟเฟกต์",
    CurrentDate: "วันที่ปัจจุบัน",
    GoldCoinTransactions: "รายได้ถั่วทอง",
    LiveStreamingDuration: "ระยะเวลาออกอากาศ",
    GoldBeanEarnings: "รายได้ถั่วทอง",
    EffectiveDays: "จำนวนวันที่มีผล",
    WarningCount: "จำนวนครั้งที่เตือน",
    give: "ให้",
    pleasewait: "กำลังดำเนินการ กรุณารอสักครู่...",

    JoinGuild: "เข้าร่วมกิลด์",
    GuildId: "รหัสกิลด์",
    PlaceholderGuildId: "กรุณากรอกรหัสกิลด์",
    PlaceholderInvitationCode: "กรุณากรอกรหัสเชิญกิลด์ของคุณ",
    InvitationCode: "รหัสเชิญ",
    noMore: "ไม่มีเพิ่มเติม",
    Recommendation: "ผู้แนะนำ (ไม่บังคับ)",
    nightLiveTime: "เวลาพิเศษ",

    GuildTotalData: "ข้อมูลรวมกิลด์",
    StatDayUnit: "",
    GuildIncome: "รายได้กิลด์",
    AnchorIncome: "รายได้ผู้ดำเนินรายการ",
    EffectiveLive: "ออกอากาศที่มีผล",
    EffectiveDays: "จำนวนวันที่มีผล",
    Income: "รายได้",
    Duration: "ระยะเวลา",

    // Join Us Page
    JoinUs: "เข้าร่วมกับเรา",
    JoinUsWelcome: "Hi, ยินดีต้อนรับเข้าร่วมกับเรา～",
    JoinUsSelectMethod: "โปรดเลือกวิธีการเข้าร่วม",
    JoinUsVideoGuild: "เข้าร่วมเป็นกิลด์วิดีโอ",
    JoinUsVideoGuildDesc: "คุณจะเน้นการสตรีมวิดีโอเป็นหลัก",
    JoinUsAudioGuild: "เข้าร่วมเป็นกิลด์เสียง",
    JoinUsAudioGuildDesc: "คุณจะเน้นการสตรีมเสียงเป็นหลัก",
    JoinUsBack: "ย้อนกลับ",
  },

  familyMain: {
    anchorList: "รายชื่อแอนเคอร์",
    anchorData: "ข้อมูลแอนเคอร์",
    guildData: "ข้อมูลกิลด์",
    guildSummaryTitle: "สรุปกิลด์",
    guildList: "รายชื่อกิลด์",
    micTime: "เวลาไมค์",
    micTimeData: "ข้อมูลเวลาไมค์",
    beansDetail: "รายละเอียดถั่วทอง",
    beansDetailData: "ข้อมูลรายละเอียดถั่วทอง",
    withdrawDetail: "รายละเอียดการถอน",
    withdrawDetailData: "ข้อมูลรายละเอียดการถอน",
    roomData: "ข้อมูลห้อง",
    roomDataData: "ข้อมูลห้อง",
    distributeBeans: "แจกจ่ายถั่ว",
    distributeBeansData: "ข้อมูลการแจกจ่ายถั่ว",
    privateShareStats: "สถิติข้อความ/แชร์",
    privateShareStatsData: "ข้อมูลสถิติข้อความ/แชร์",
    roomTurnover: "ยอดห้อง",
    roomTurnoverData: "ข้อมูลยอดห้อง",
    incomeRecord: "บันทึกรายได้",
    incomeRecordData: "ข้อมูลบันทึกรายได้",
    knapsackGiftDetail: "รายละเอียดของขวัญกระเป๋า",
    knapsackGiftData: "ข้อมูลของขวัญกระเป๋า",
    roomFilterTitle: "ตัวกรองห้อง",
    roomFilterConfirm: "เสร็จสิ้น",
    allRooms: "ห้องทั้งหมด",
    selectRoom: "เลือกห้อง",
  },
  anchorList: {
    countLabel: "【{count} ผู้ดำเนินรายการ】",
    searchPlaceholder: "กรุณาใส่รหัสแอนเคอร์",
    search: "ค้นหา",
    joinTimeLabel: "เวลาเข้าร่วม：",
    noData: "ไม่มีข้อมูล",
    nickNameFallback: "ชื่อผู้ดำเนินรายการ",
    invalidUserId: "กรุณาใส่รหัสเป็นตัวเลข",
  },

  salaryMain: {
    searchPlaceholder: "ป้อน ID แอนเคอร์เพื่อค้นหา",
    dateSelect: "เลือกวันที่",
    byDay: "ตามวัน",
    byRange: "ตามช่วง",
    searchTime: "เวลาค้นหา",
    to: " ถึง ",
    dataSummary: "สรุปข้อมูล",
    totalMicTime: "เวลาไมค์รวม",
    totalHeartGiftTurnover: "ถั่วทองโชคดีรวม",
    totalLuxuryGiftTurnover: "ถั่วทองรวม",
    member: "สมาชิก",
    anchorProfile: "โปรไฟล์แอนเคอร์",
    micTime: "เวลาไมค์",
    heartGiftTurnover: "ถั่วทองโชคดี",
    luxuryGiftTurnover: "ถั่วทองรวม",
    roomNumber: "หมายเลขห้อง",
    pleaseSelectTime: "เลือกเวลา",
    pleaseEnterNumber: "กรุณาป้อนตัวเลข",
    selectAll: "ทั้งหมด",
    minute: "นาที",
    second: "วินาที",
    anchorTotalData: "ข้อมูลรวมแอนเคอร์",
    totalSpecialEffectBeans: "ถั่วทองเอฟเฟกต์รวม",
    totalAllBeans: "ถั่วทองรวม",
  },

  anchorCenter: {
    todayLiveData: "ข้อมูลไลฟ์วันนี้",
    time: "เวลา",
    duration: "ระยะเวลา",
    income: "รายได้ถั่วทองโชคดี",
    giftRecord: "ประวัติของขวัญ",
    withdraw: "ถอนเงิน",
    tipsUpdate: "หมายเหตุ: ข้อมูลวันนี้อัปเดตทุกนาที",
    overallData: "ข้อมูลภาพรวม",
    totalDays: "จำนวนวันที่รวม",
    totalDuration: "ระยะเวลารวม",
    totalTurnover: "ถั่วทองโชคดีรวม",
    totalIncome: "เงินเดือนพื้นฐานรวม",
    totalBeans: "ถั่วทองรวม",
    luckyBeans: "ถั่วทองโชคดี",
    specialBeans: "ถั่วทองเอฟเฟกต์",
    baseSalary: "เงินเดือนพื้นฐาน",
    totalIncomeLabel: "รายได้รวม",
    dataListMonth: "รายการข้อมูล [{month}]",
    filter: "กรอง",
    date: "วันที่",
    turnover: "ยอดหมุนเวียน",
    beans: "ถั่วทอง",
    zeroTime: "0 ชม. 0 นาที",
    year: "",
    month: "",
    anchorTotalData: "ข้อมูลรวมแอนเคอร์",
    anchorNicknamePlaceholder: "ชื่อเล่นแอนเคอร์",
    myGuild: "กิลด์ของฉัน",
    guildNicknamePlaceholder: "ชื่อเล่นกิลด์",
    anchorDataSection: "ข้อมูลแอนเคอร์",
    todayDataTitle: "ข้อมูลวันนี้",
    liveStreamDuration: "ระยะเวลาไลฟ์",
    totalGoldBeans: "ถั่วทองรวม",
    nextDayLuckyReward: "รางวัลโชคดีวันถัดไป",
    specialExtraReward: "รางวัลพิเศษเอฟเฟกต์เพิ่มเติม",
    weekLuckyReward: "รางวัลโชคดีสัปดาห์นี้",
    estimatedTotalEarnings: "รายได้โดยประมาณรวม",
    grandTotal: "รวมทั้งหมด",
  },

  micTime: {
    searchPlaceholder: "ป้อน ID แอนเคอร์",
    search: "ค้นหา",
    dateSelect: "เลือกวันที่",
    today: "วันนี้",
    thisWeek: "สัปดาห์นี้",
    lastWeek: "สัปดาห์ที่แล้ว",
    totalMicTime: "เวลาไมค์รวม",
    date: "วันที่",
    anchorInfo: "ข้อมูลแอนเคอร์",
    micTime: "เวลาไมค์",
    pleaseSelectTime: "เลือกเวลา",
    selectAll: "ทั้งหมด",
    minute: "นาที",
    second: "วินาที",
  },

  anchroOtayonii: {
    dateSelect: "เลือกวันที่",
    byDay: "ตามวัน",
    byRange: "ตามช่วง",
    searchTime: "เวลาค้นหา",
    to: " ถึง ",
    dataSummary: "สรุปข้อมูล",
    totalLuckyGift: "ของขวัญ Lucky ทั้งหมด",
    totalSpecialGift: "ของขวัญ Special ทั้งหมด",
    totalKnapsackGift: "ของขวัญกระเป๋าทั้งหมด",
    anchorInfo: "ข้อมูลแอนเคอร์",
    luckyGift: "ของขวัญ Lucky",
    specialGift: "ของขวัญ Special",
    knapsackGift: "ของขวัญกระเป๋า",
    pleaseSelectTime: "เลือกเวลา",
    selectAll: "ทั้งหมด",
  },

  roomCm: {
    dateSelect: "เลือกวันที่",
    today: "วันนี้",
    thisWeek: "สัปดาห์นี้",
    lastWeek: "สัปดาห์ที่แล้ว",
    dataSummary: "สรุปข้อมูล",
    totalTurnover: "ถั่วทองโชคดีรวม",
    totalTurnoverBeans: "ถั่วทองรวม",
    date: "วันที่",
    heartGiftTurnover: "ถั่วทองโชคดี",
    specialGiftTurnover: "ถั่วทองรวม",
    room: "ห้อง",
    pleaseSelectTime: "เลือกเวลา",
    selectAll: "ทั้งหมด",
    minute: "นาที",
    second: "วินาที",
  },

  weekProfit: {
    dateSelect: "เลือกวันที่",
    time: "เวลา",
    type: "ประเภท",
    beans: "ถั่ว",
    pleaseSelectTime: "เลือกเวลา",
  },

  withdrawRecord: {
    withdrawAmount: "จำนวนที่ถอน",
    withdrawStatus: "สถานะการถอน",
    NoData: "ไม่มีข้อมูล",

    UnderReview: "กำลังตรวจสอบ",
    Processing: "กำลังโอน",
    Completed: "เสร็จสิ้น",
    Rejected: "ถูกปฏิเสธ",
    Failed: "ล้มเหลว",

    Pending: "รอดำเนินการ",
    Success: "สำเร็จ",
    NoMore: "ไม่มีเพิ่มเติม",
    PleaseWait: "กรุณารอสักครู่...",
    PleaseSelect: "กรุณาเลือก",
    Date: "วันที่",
    RealAmount: "จำนวนที่ได้รับจริง",
    Fee: "ค่าธรรมเนียม",
    Status: "สถานะ",
    Remark: "หมายเหตุ",
  },

  coinManagement: {
    myGoldenbeans: "ถั่วทองของฉัน",
    Withdraw: "ถอน",
    ExchangeGoldCoins: "แลกเปลี่ยน",
    HostInformation: "ข้อมูลผู้ดำเนินรายการ",
    WithdrawalCurrency: "สกุลเงินถอน",
    SelectWithdrawalCurrency: "กรุณาเลือกสกุลเงินถอน",
    FiatCurrency: "เงินสกุลท้องถิ่น",
    PleaseSelectWithdrawalCurrency: "กรุณาเลือกสกุลเงินถอน",
    tips: "หมายเหตุ:",
    tipsp0: "อัตราถอน: 10,000 ถั่วทอง = 0.5 USD",
    tipsp1:
      "ขั้นต่ำการถอน: 100,000 ถั่วทอง ถอนได้เฉพาะเป็นจำนวนเท่าของ 10,000 (การถอนครั้งแรกต้องมี 200,000 ถั่วทอง หลังถอนสำเร็จจะลดลงเหลือ 100,000)",
    tipsp2:
      "ผูกบัญชีถอน เนื่องจากช่องทางชำระต่างประเทศหลากหลายและไม่มีเอกสารคงที่ การเพิ่มบัญชีเป็นหัวหน้าครอบครัวต้องรองรับการยืนยันหลายประเภท",
    tipsp3: "ต้องยืนยันตัวตน Host",
    tipsp4: "ผูกหมายเลขโทรศัพท์",
    tipsp5:
      "หากขั้นตอนใดขั้นตอนหนึ่งข้างต้นยังไม่ครบ จะไม่สามารถถอนได้ ระบบจะแจ้งหรือนำทางผู้ใช้",
    tipsp6: "① แจ้งเท่านั้น",
    tipsp7: "② ไปหน้าผูกหมายเลขโทรศัพท์ หลังเสร็จกลับหน้านี้",
    tipsp8: "③ ไปหน้ายืนยันตัวตน หลังเสร็จกลับหน้านี้",
    tipsp9: "④ ไปหน้าผูกบัญชี หลังเสร็จกลับหน้านี้",
    tipsp10: "การถอนมีค่าธรรมเนียม ขึ้นกับช่องทาง",
    tipsp11: "1. อัตราแลก: ถั่วทอง 1000 = เหรียญทอง 500",
    tipsp12: "2. ขั้นต่ำ 5000 ถั่วทอง ต้องเป็นเท่าของ 1000",
    tipsp13: "3. แลกแล้วยกเลิกไม่ได้ กรุณาแลกอย่างระมัดระวัง",
    num: "จำนวน",
    Custom: "กำหนดเอง",
    PleaseEnter: "กรุณากรอก",
    Redeem: "แลก",
    SelectType: "เลือกประเภท",
    GoldBeans: "ถั่วทอง",
    GoldCoin: "เหรียญ",
    WithdrawalAmount: "จำนวนถอน",
    PleaseNum: "กรอกจำนวนเหรียญที่ต้องการถอน",
    All: "ทั้งหมด",
    Withdraw: "ถอน",

    Incomedetails: "รายละเอียดรายได้",
    all: "ทั้งหมด",
    gift: "ของขวัญ",
    system: "ระบบ",
    withdraw: "ถอน",
    exchange: "แลกเปลี่ยน",
    balance: "ยอดคงเหลือ",
    Expensedetails: "รายละเอียดรายจ่าย",
    Nobeans: "ไม่มีถั่วทองที่แลกได้",

    Record: "ประวัติธุรกรรม",
    WithdrawalRecord: "ประวัติการถอน",
  },

  contactUs: {
    Officialcustomerservice: "บริการลูกค้าอย่างเป็นทางการ",
    ContactUs: "ติดต่อเรา",
    Issueofguild: "เรื่องลงทะเบียนกิลด์",
  },

  myInvitation: {
    MyGoldBeans: "ถั่วทองของฉัน",
    Share: "แชร์เชิญเพื่อน",
    CopyLink: "คัดลอกลิงก์",
    GoldCoinEarnedToday: "ถั่วทองที่ได้วันนี้",
    TotalGoldCoin: "ถั่วทองสะสมรวม",
    tips: "เชิญและผูกผู้ใช้ใหม่เติมเงินใดก็ได้ ได้รางวัลถั่วทอง 1% (ลงทะเบียนเกิน 48 ชม. ผูกไม่ได้)",
    tips2: "ลงทะเบียนเกิน 48 ชั่วโมงแล้วผูกไม่ได้",
    MyInvitations: "การเชิญของฉัน",
    BillingDetails: "รายละเอียดบิล",
    Total: "รวม",
    People: "คน",
    GoldCoinGiven: "ถั่วทองที่ให้",
    GiveGoldCoin: "ให้+",
    InvitationLink: "ลิงก์เชิญ",
    ShareQR: "แชร์ QR",
    InviteCount: "จำนวนผู้ได้รับเชิญ",
    RevenueBeans: "ถั่วทองที่ได้รับ",
    InvitationDetails: "รายละเอียดการเชิญ",
    EarningsDetails: "รายละเอียดรายได้",
    NickNameLabel: "ชื่อเล่น",
    SaveImage: "บันทึกรูปภาพ",
    QRScanHint: "สแกน QR code หรือใช้ลิงก์เชิญเพื่อเข้าร่วม",
    ShareTagline: "Share & Chat & Live",
    GoldenBeanUnit: "ถั่วทอง",
    CommissionRate: "ส่วนแบ่ง {rate}%",
  },

  userMisconduct: {
    title1: "ละเมิดเนื้อหา I",
    p1: "1. แสดงหรือเผยแพร่เนื้อหาที่จำกัด:",
    p2: "รวมถึงเนื้อหาลามก ความรุนแรง หรือเหยียดเชื้อชาติ ผ่านแชท ลีฟ หรือฟีเจอร์อื่นของ Rain Live",
    p3: "2. แพร่คำพูดแสดงความเกลียดชัง:",
    p4: "ห้ามคำพูดแสดงความเกลียดชังต่อศาสนา เชื้อชาติ การเมือง หรืออัตลักษณ์ชาติ",
    p5: "3. โปรโมตหรือชวนเข้าร่วม:",
    p6: "ห้ามชวนผู้ใช้เข้าร่วมแอปหรือแพลตฟอร์มอื่นผ่านลีฟ แชท หรือคอมเมนต์ที่ผ่านการตรวจ",
    title2: "ผลที่ตามมา",
    p7: "บัญชี อุปกรณ์ หรือ IP ที่เกี่ยวข้องอาจถูกแบน",

    title3: "ละเมิดเนื้อหา II",
    p8: "1. แชร์ข้อมูลส่วนตัว:",
    p9: "ห้ามแชร์ข้อมูลส่วนตัว เช่น เบอร์โทร รหัสบัญชี บัญชี Facebook รูป ผ่านลีฟ คอมเมนต์ หรือแชทของ Rain Live",
    p10: "2. ใช้บัญชีในทางผิด:",
    p11: "ห้ามให้ เช่า หรือขายบัญชี Rain Live ให้ผู้อื่น",
    p12: "3. ใช้ข้อมูลส่วนตัว:",
    p13: "ห้ามใช้หรือแชร์ข้อมูลส่วนตัว (รูป ชื่อเล่น ฯลฯ) โดยไม่ยินยอม เพื่อผลประโยชน์หรือโจมตีผู้อื่น",
    title4: "ผลที่ตามมา",
    p14: "ผู้ละเมิดจะถูกแบนถาวร",
  },

  landingPage: {
    info1: "Rain Live Circle",
    info2: "Apl Internal Purchase",
    item1: "45K รีวิว",
    item2: "ดาวน์โหลด",
    item3: "ระดับ 3 3+",
    btn: "ดาวน์โหลด",
    title: "เกี่ยวกับ Rain Live",
    content:
      "Rain Live เป็นแอปสตรีมมิ่งออนไลน์สำหรับทุกคน รวมเสียง วิดีโอ ความบันเทิง และเกม แพลตฟอร์มรวบรวมผู้ดำเนินรายการคุณภาพ เป็นแพลตฟอร์มลีฟที่มีเนื้อหาลึก PK ดุ เดย์ แก้กของขวัญ สัมผัสประสบการณ์ระดับวีไอพี",
    tips: "Rain Live อันดับ 1 ในรายการแอปโซเชียลฟรียอดนิยม",
  },

  equityLevel: {
    Experience: "ค่าประสบการณ์",
    Level: "ระดับปัจจุบัน",
    Berikutnya: "ระยะถึงอัพเกรด",
    title1: "สิทธิ์ระดับ",
    desc1:
      "ระดับสูง ไอคอนยิ่งมีเกียรติ ยิ่งได้ความสนใจจากผู้ดำเนินรายการที่ชอบ",
    title2: "วิธีอัพเกรด",
    desc2: "1. ระดับผู้ใช้ขึ้นกับค่าประสบการณ์จากการใช้จ่ายของขวัญ",
    desc3: "2. ได้ค่าประสบการณ์จากการส่งของขวัญทุกวันเพื่ออัพระดับ",
    desc4: "3. ของขวัญโชคดี: ใช้ 1 เหรียญ ได้ 1 ค่าประสบการณ์",
    desc5: "4. ของขวัญเอฟเฟกต์: ใช้ 1 เหรียญ ได้ 10 ค่าประสบการณ์",
    title3: "สิทธิ์ระดับ",
    desc6: "ระดับสูง ไอคอนยิ่งมีเกียรติ ยิ่งได้ความสนใจจากผู้ใช้",
    desc7: "1. ระดับผู้ดำเนินรายการขึ้นกับค่าประสบการณ์จากการรับของขวัญ",
    desc8: "2. ได้ค่าประสบการณ์จากการรับของขวัญทุกวันเพื่ออัพระดับ",
    title6: "ระดับผู้ใช้",
    title7: "ระดับ",
    title8: "เหรียญระดับ",
    title9: "ระดับผู้ดำเนินรายการ",
    title10: "ค่าประสบการณ์สะสมรวม",
    LevelDescription: "คำอธิบายระดับ",
    tabUser: "ผู้ใช้",
    tabEx: "Ex เหรียญ",
    tabAnchor: "ผู้ดำเนินรายการ",
    titleOverview: "ภาพรวมระดับความมั่งคั่ง",
    nickNameUser: "ชื่อผู้ใช้",
    nickNameAnchor: "ชื่อผู้ดำเนินรายการ",
    nickNameEx: "ชื่อผู้ใช้",
    exPrivilegeDesc: "ระดับสูง ไอคอนยิ่งมีเกียรติ ยิ่งได้ความสนใจจากผู้ใช้",
    exDesc1: "1. ระดับ Ex ขึ้นกับค่าประสบการณ์จากการใช้จ่ายของขวัญ",
    exDesc2: "2. ได้ค่าประสบการณ์จากการส่งของขวัญทุกวันเพื่ออัพระดับ",
    exDesc3: "3. ของขวัญโชคดี: ใช้ 1 เหรียญ ได้ 1 ค่าประสบการณ์",
    exDesc4: "4. ของขวัญเอฟเฟกต์: ใช้ 1 เหรียญ ได้ 10 ค่าประสบการณ์",
    anchorPrivilegeDesc: "ระดับสูง ไอคอนยิ่งมีเกียรติ ยิ่งได้ความสนใจจากผู้ใช้",
    anchorDesc1: "1. ระดับผู้ดำเนินรายการขึ้นกับค่าประสบการณ์จากการรับของขวัญ",
    anchorDesc2: "2. ได้ค่าประสบการณ์จากการรับของขวัญทุกวันเพื่ออัพระดับ",
  },

  applyJoin: {
    tips1: "กรุณากรอกบัญชี WhatsApp ของคุณ",
    title2: "ข้อกำหนดรูป",
    tips2: "กรุณาแสดงใบหน้าและครึ่งตัว และทำท่ามือแบบแมว",
    tips3: "รูปใช้เพื่อการตรวจของบริษัทเท่านั้น และหน่วยงานจะเก็บเป็นความลับ",
    tips4: "รูปต้องเป็นตัวคุณเอง",
    title3: "ข้อกำหนดวิดีโอ",
    tops5: "วิดีโอต้องเป็นตัวคุณเอง",
    tips6: "ความยาววิดีโอ 10–20 วินาที",
    status1: "ส่งตรวจ",
    status2: "กำลังตรวจ",
    status3: "ตรวจผ่าน",
    status4: "ตรวจไม่ผ่าน",
    LiveMode: "โหมดลีฟ",
    Video: "วิดีโอ",
    Voice: "เสียง",
    MP4: "กรุณาเลือกวิดีโอรูปแบบ MP4",
    pngOrJpg: "กรุณาอัปโหลดรูป PNG หรือ JPG",
    UploadingWait: "กำลังอัปโหลด กรุณารอ",
    CompleteInformation: "กรุณากรอกข้อมูลให้ครบ",
    TabPersonalStreamer: "การยืนยันตัวตน Host",
    TabJoinGuild: "เข้าร่วมกิลด์",
    faceVerifyTitle: "การยืนยันใบหน้า",
    faceVerifyPending: "รอยืนยัน",
    faceVerifyVerified: "ยืนยันแล้ว",
    faceVerifyError: "คุณได้ยืนยันบัญชีอื่นไปแล้ว จึงไม่สามารถยืนยันได้",
    faceVerifyRequired: "กรุณาทำการยืนยันใบหน้าให้เสร็จก่อน",
    faceVerifyNotSupported: "สภาพแวดล้อมปัจจุบันไม่รองรับการยืนยันใบหน้า",
    faceVerifyStart: "เริ่ม",
    faceVerifyRetry: "ลองอีกครั้ง",
    faceVerifySuccess: "ยืนยันสำเร็จ",
    faceVerifyFail: "ยืนยันไม่สำเร็จ",
  },

  cancelAccount: {
    title: "สมัครยกเลิกบัญชี",
    tips: "ข้อมูลต่อไปนี้จะถูกล้างและกู้คืนไม่ได้:",
    p1: "เมื่อยกเลิกบัญชี ข้อมูลทั้งหมดจะถูกลบถาวร (รวมผู้ติดตาม แฟน ฯลฯ) บริการที่ซื้อจะไม่คงอยู่และโอนให้บัญชีอื่นไม่ได้ (VIP เลขสวย กรอบอวาตาร์ ฯลฯ)",
    p2: "บัญชี Facebook Twitter Apple Google ที่ผูกจะถูกยกเลิกการผูก หลังยกเลิกสามารถลงทะเบียนใหม่ได้",
    p3: "ข้อมูลการสมัครผู้ดำเนินรายการจะถูกยกเลิกการผูก และสามารถผูกกับบัญชีอื่นได้ (ถ้าเป็นผู้ดำเนินรายการลีฟ สามารถยืนยันตัวตนและออกอากาศใหม่ได้)",
    p4: "หลังยกเลิกบัญชี เหรียญทอง เพชร ค่าประสบการณ์ ยาน ฯลฯ ที่เหลือจะถูกล้าง ความเสียหายใดที่เกิดผู้ยื่นยกเลิกเป็นผู้รับผิดชอบ",
    p5: "ถ้าเป็นหัวหน้ากิลด์ การยื่นยกเลิกจะทำให้กิลด์สลาย (หลังสลายแล้ว ยกเลิกคำขอยกเลิกก็ไม่สามารถคืนกิลด์ได้) ถ้าเป็นสมาชิกกิลด์ การยกเลิกบัญชีจะทำให้ออกจากกิลด์โดยอัตโนมัติ (ภายใน 15 วันสามารถถอนคำขอยกเลิกเพื่อคืนได้)",
    p6: "ถ้าเป็นหัวหน้าครอบครัว ต้องสลายหรือออกจากครอบครัวก่อนยื่นยกเลิกบัญชี",
    p7: "ถ้าเป็นสมาชิกครอบครัว (ไม่ใช่หัวหน้า) การยื่นยกเลิกบัญชีจะทำให้ออกจากครอบครัวทันที (ภายใน 15 วันถอนคำขอยกเลิกจะไม่คืนสถานะครอบครัว)",
    p8: "หลังยื่นยกเลิก มีระยะอุทธรณ์ 15 วัน เข้าสู่ระบบในระยะนี้จะยกเลิกการยกเลิกโดยอัตโนมัติ หลังครบระยะ บัญชีจะถูกยกเลิกถาวรและกู้คืนไม่ได้ หากต้องกู้เพราะไม่ใช่本人หรือปฏิบัติผิดพลาด กรุณาติดต่อฝ่ายบริการ (WhatsApp: +62 81188011180 อีเมล: rainlive888@gmail.com)",
  },

  Proxy: {
    Hello: "สวัสดีครับ/ค่ะ,",
    Welcome: "ยินดีต้อนรับสู่ Rain Chat!",
    Account: "บัญชี",
    Pleaseenter: "กรุณากรอก",
    Password: "รหัสผ่าน",
    Login: "เข้าสู่ระบบ",
    MyAgent: "เอเยนต์ของฉัน",
    Nickname: "ชื่อเล่นเอเยนต์",
    CoinBalance: "ยอดเหรียญเอเยนต์",
    TransferRecord: "ประวัติโอน",
    Recharge: "เติมเงิน",
    ExchangeProxyCoin: "แลกเหรียญเอเยนต์",
    TransferInformation: "กรุณากรอกข้อมูลโอน",
    Reset: "รีเซ็ต",
    RecipientID: "รหัสผู้รับ",
    RecipientNickname: "ชื่อเล่นผู้รับ",
    TransferAmount: "จำนวนโอน",
    TotalTransferAmount: "ทั้งหมด",
    Transfer: "โอน",
    KindReminder: "ข้อความเตือน",
    DoubleCheck: "กรุณาตรวจสอบข้อมูลให้ถูกต้อง",
    SelectAmount: "กรุณาเลือกจำนวนเติม",
    SelectMonth: "เลือกเดือน",
    Username: "ชื่อผู้ใช้",
    TransferTime: "เวลาโอน",
    AutoFill: "กรอกอัตโนมัติ",
    Rechargeselection: "ตัวเลือกเติมเงิน",
    ProxyCurrency: "เหรียญเอเยนต์ไม่พอ",
    PaymentAmount: "จำนวนชำระ",
    PleaseSelectAmount: "กรุณาเลือกจำนวนเติม",
    GoldExchangeTitle: "แลกถั่วทองเป็นเหรียญเอเยนต์",
    GoldBalanceLabel: "ยอดถั่วทอง: ",
    InputGoldPlaceholder: "กรอกจำนวนถั่วทอง",
    AvailableProxyCoin: "เหรียญเอเยนต์ที่จะได้รับ",
    GiftProxyCoin: "แถม {amount} เหรียญเอเยนต์",
    GiftBonusPercent: "แถม {bonus}%",
    Exchange: "แลก",
    Tip: "ข้อความเตือน",
    ExchangeConfirmHtml:
      'คุณกำลังจะใช้ <span class="green">{gold}</span> ถั่วทองเพื่อแลกเป็น <span class="green">{coin}</span><br/>เหรียญเอเยนต์ พร้อมแถม <span class="orange">{gift}</span> เหรียญเอเยนต์',
    ExchangeSuccessTitle: "แลกสำเร็จ",
    ExchangeSuccessText: "เหรียญเอเยนต์เข้าบัญชีแล้ว กรุณาตรวจสอบ",
    ExchangeFail: "แลกไม่สำเร็จ",
    RequestFail: "คำขอล้มเหลว",
  },

  bd: {
    incomeDetail: {
      title: "รายละเอียดรายได้",
      lastWeekIncome: "รายได้สัปดาห์ที่แล้ว",
      totalIncome: "รายได้รวมทั้งหมด",
      guildId: "รหัสกิลด์",
      date: "วันที่",
      thisWeek: "สัปดาห์นี้",
      lastWeek: "สัปดาห์ที่แล้ว",
      beforeLastWeek: "สัปดาห์ก่อนหน้า",
      thisMonth: "เดือนนี้",
      lastMonth: "เดือนที่แล้ว",
      summary: "สรุป",
      guildName: "ชื่อกิลด์",
      guildIncome: "รายได้กิลด์",
      effectiveLive: "ออกอากาศที่มีผล",
      myIncome: "รายได้ของฉัน",
      noData: "ไม่มีข้อมูล",
      searching: "กำลังค้นหาข้อมูลรายได้",
      showingSummary: "แสดงข้อมูลสรุป",
    },
    index: {
      title: "BD",
      guildCount: "จำนวนกิลด์",
      weekEstimatedIncome: "รายได้โดยประมาณสัปดาห์นี้",
      lastWeekIncome: "รายได้สัปดาห์ที่แล้ว",
      inviteCode: "รหัสเชิญ",
      searchPlaceholder: "กรุณากรอกรหัสกิลด์",
      lastWeek: "สัปดาห์ที่แล้ว",
      guildName: "ชื่อกิลด์",
      guildId: "รหัสกิลด์",
      weekIncome: "รายได้กิลด์สัปดาห์นี้",
      myIncome: "รายได้ของฉัน",
      effectiveLive: "ออกอากาศที่มีผล",
      bindDays: "จำนวนวันที่ผูก",
      copySuccess: "คัดลอกรหัสเชิญแล้ว",
      enterGuildId: "กรุณากรอกรหัสกิลด์",
      searchGuild: "ค้นหารหัสกิลด์",
      search: "ค้นหา",
      summary: "สรุป",
      selectWeek: "เลือกสัปดาห์",
      loading: "กำลังโหลด...",
      loadFailed: "โหลดล้มเหลว",
      networkError: "เครือข่ายผิดพลาด กรุณาลองใหม่",
    },
  },

  noble: {
    expireTime: "หมดอายุ",
    canReceive: "รับได้ {coin} เหรียญ",
    receive: "รับทันที",
    received: "รับแล้ว",
    becomeNoble: "เป็น VIP",
    totalCanGet: "รวมรับได้ {price}{totalCoin} เหรียญ",
    silver: "เงิน",
    gold: "ทอง",
    platinum: "แพลทินัม",
    diamond: "เพชร",
    obsidian: "ออบซิเดียน",
    type: "สิทธิประโยชน์",
    levelReward: "คำอธิบาย",
    dailyExCoin: "Ex-Coin ฟรี",
    rechargeReward: "Top up",
    gameSupport: "Game",
    exclusiveDecoration: "ชุดแต่ง",
    decoration: {
      profileCard: "การ์ดโปรไฟล์",
      bubble: "กรอบแชท",
      vehicle: "ยานพาหนะ",
      avatarFrame: "กรอบโปรไฟล์",
      badge: "ป้ายตราสัญลักษณ์",
    },
    dailyFreeExCoin: "{amount} Ex-Coin ฟรีรายวัน",
    monthlyRechargeBenefit:
      "{percent}% จากยอดเติมเงินรายเดือน เป็นเงินรางวัล เดือนหน้าโอนเข้าบัญชี",
    monthlyGameConsumptionBenefit:
      "{percent}% จากการใช้เหรียญในเกมรายเดือน เดือนหน้าโอนเข้าบัญชี",
    privileges: {
      getCoin: "รับเหรียญ",
      avatarFrame: "กรอบอวาตาร์",
      medal: "เหรียญ",
      vehicle: "ยาน",
      purchaseNotification: "แจ้งการซื้อ",
      chatBubble: "ฟองแชท",
      colorfulNickname: "ชื่อเล่นสี",
      specialId: "เลขสวย",
      mystery: "ลึกลับ",
      exclusiveService: "บริการพิเศษ",
      title: "สิทธิประโยชน์",
      Effect: "เอฟเฟกต์เข้าห้อง",
    },
    receiveSuccess: "รับสำเร็จ",
    contactOperation: "กรุณาติดต่อฝ่ายปฏิบัติการ",
    level1Recharge: "VIP เงิน / 30 วัน",
    level2Recharge: "VIP ทอง / 30 วัน",
    level3Recharge: "VIP แพลทินัม / 30 วัน",
    level4Recharge: "VIP เพชร / 30 วัน",
    level5Recharge: "VIP ดำ / 30 วัน",
    vipCenterTitle: "ศูนย์ VIP",
    expireTimeText: "หมดอายุ",
    openVip: "เติมเงินเพื่อเปิดใช้",
    reachedLevel: "ถึงระดับแล้ว",
    stillNeedCoins: "ต้องเพิ่มอีก {amount} เหรียญ",
    stillNeedCoinsToKeepGrade: "ต้องเพิ่มอีก {amount} เพื่อรักษาระดับ",
    stillNeedCoinsToActivate: "ต้องเพิ่มอีก {amount} เพื่อเปิดใช้ {levelName}",
    keepGradeCompleted: "การต่ออายุ",
    keepGradeProgress: "ความคืบหน้ารักษาระดับ: ",
    progress: "ความคืบหน้า",
  },

  bonusActivity: {
    title: "กิจกรรมโบนัสลีฟ",
    activityTime: "ระยะกิจกรรม: 7 เม.ย. 00:00 - 4 พ.ค. 23:59:59 (UTC+8)",
    rewardRules: "กฎรางวัล",
    reward: "รางวัล",
    totalReceived: "รับรวม",
    bonus: "โบนัส",
    claim: "รับ",
    claimed: "รับแล้ว",
    notAchieved: "ยังไม่ถึง",
    duration: "ระยะเวลา(ชม.)",
    target: "เป้า(เหรียญ)",
    note: "หมายเหตุ: ถึงเป้าแล้ว รับโบนัสได้วันถัดไป",
    activityCalendar: "ปฏิทินกิจกรรม",
    april: "เมษายน",
    may: "พฤษภาคม",
    claimSuccess: "รับสำเร็จ",
  },

  bonusActivityRule: {
    activityDescription: "คำอธิบายกิจกรรม",
    descriptionContent:
      "นอกจากรางวัลพื้นฐาน ผู้ดำเนินรายการจะได้โบนัสเพิ่มจาก Rain Live",
    activityTime: "ระยะกิจกรรม",
    resetTime: "รีเซ็ตทุกวัน 0:00 (UTC+8)",
    pointsReward: "รางวัลคะแนน",
    coinsReward: "รางวัลเหรียญ",
    participationTimes: "เข้าร่วม {times} ครั้ง",
    points: "คะแนน",
    exchange: "แลก",
    pointsMall: "มอลล์คะแนน",
    note: "หมายเหตุ",
    rule1: "1. ได้คะแนนจากทำภารกิจรายวัน",
    rule2: "2. รางวัลในมอลล์คะแนนจะเปลี่ยนไม่ประจำ",
    rule3: "3. แลกแล้วคะแนนคืนไม่ได้ กรุณาแลกอย่างระมัดระวัง",
  },

  inviteFriends: {
    invitationEventTitle: "กิจกรรมเชิญ",
    inviteAndEarnRewards: "เชิญแล้วรับรางวัล",
    eventPeriod: "ระยะกิจกรรม: 7 เม.ย. 00:00 - 4 พ.ค. 23:59:59 (UTC+8)",
    invitationRecord: "ประวัติการเชิญ",
    eventDetails: "รายละเอียดกิจกรรม",
    week1DateRange: "สัปดาห์ 1: 7–13 เม.ย.",
    totalInvitedExample: "จำนวนที่เชิญ",
    level1RewardText: "Lv.1 เชิญ 20 คน 20000 เหรียญ",
    level2RewardText: "Lv.2 เชิญ 50 คน 50000 เหรียญ",
    level3RewardText: "Lv.3 เชิญ 100 คน 100000 เหรียญ",
    statusClaimed: "รับแล้ว",
    actionClaim: "รับ",
    statusNotAchieved: "ยังไม่ถึง",
    topUpRewardsLabel: "รางวัลเติมเงิน:",
    copyInvitationLink: "คัดลอกลิงก์เชิญ",
    rewardNote:
      "หมายเหตุ: เมื่อผู้ถูกเชิญเติมเงิน คุณจะได้ 2% ของเหรียญนั้นเป็นรางวัล",
    copySuccess: "คัดลอกสำเร็จ",
    claimSuccessExample: "รับ 20000 เหรียญสำเร็จ",
    userIDLabel: "User ID",
    userNameLabel: "User Name",
    timeLabel: "Time",
    topUpLabel: "Top-Up",
    eventPurposeTitle: "【วัตถุประสงค์】",
    eventPurposeDesc:
      "เพื่อขอบคุณผู้ใช้ที่สนับสนุน Rain Live มาอย่างยาวนาน แพลตฟอร์มจัดกิจกรรม「เชิญเพื่อน・รับของรางวัล」 ขอเชิญคุณและเพื่อนร่วมสัมผัสลีฟ",
    eventDurationTitle: "【ระยะเวลา】",
    eventDateRange: "7 เม.ย. 2025 – พ.ค. 2025",
    eventCycleDesc: "รวม 4 สัปดาห์ เปิดรางวัลรอบใหม่ทุกจันทร์ 0:00 (UTC+8)",
    rewardRulesTitle: "【กฎรางวัล】",
    rewardRulesDesc1: "นอกจากรางวัลกิจกรรมนี้ ยังได้โบนัสเชิญเดิม:",
    rewardRulesDesc2: "2% ของเหรียญที่ผู้ถูกเชิญเติมจะให้ผู้เชิญ",
    importantNotesTitle: "【ข้อควรระวัง】",
    importantNotesDesc:
      "⚠️ ห้ามใช้บัญชีปลอม บอต หรือวิธีโกงอื่นเพื่อรับรางวัล หากพบจะยึดรางวัลทั้งหมดและอาจจำกัดบัญชี",
  },

  bonusPoints: {
    activityTime: "ระยะกิจกรรม",
    resetTime: "รีเซ็ตทุกวัน 0:00 (UTC+8)",
    pointsReward: "รางวัลคะแนน",
    coinsReward: "รางวัลเหรียญ",
    participationTimes: "เข้าร่วม {times} ครั้ง",
    points: "คะแนน",
    exchange: "แลก",
    pointsMall: "มอลล์คะแนน",
    betSum: "ยอดปัจจุบัน",
    note: "หมายเหตุ",
    rule1: "1. ได้คะแนนจากทำภารกิจรายวัน",
    rule2: "2. รางวัลในมอลล์คะแนนจะเปลี่ยนไม่ประจำ",
    rule3: "3. แลกแล้วคะแนนคืนไม่ได้ กรุณาแลกอย่างระมัดระวัง",
    coins: "เหรียญ",
    claim: "รับ",
    claimed: "รับแล้ว",
    notAchieved: "ยังไม่ถึง",
    reach: "ถึง",
  },

  gameRanking: {
    notRanked: "ไม่อยู่ในอันดับ",
    distanceToRank: "ห่างอันดับ 50 อีก {points} คะแนน",
    distanceToBeforeRank: "ห่างอันดับ {rankId} อีก {points} คะแนน",
    rank1: "คุณอยู่อันดับ 1 แล้ว",
    today: "วันนี้",
    yesterday: "เมื่อวาน",
    ruleBtn: "Rule",
    rules: {
      pointsStats: {
        title: "กฎสถิติคะแนน",
        conversion:
          "1. มาตรฐานแปลง: เหรียญทอง 1 = 1 คะแนนในกิจกรรม คะแนนคำนวณจากจำนวนเหรียญ",
        timeRange:
          "2. ช่วงเวลา: รอบรายวัน 00:00–23:59 (UTC+8) ข้อมูลนอกช่วงจะนับวันถัดไป",
      },
      ranking: {
        title: "กฎอันดับและรางวัล",
        basis:
          "3. อันดับจากคะแนนสุดท้ายรายวัน (ยอดเหรียญวันนั้น) เรียงจากมากไปน้อย",
        rewards: "4. การตั้งรางวัล:",
        reward1: "อันดับ 1: 250,000 เหรียญทอง",
        reward2: "อันดับ 2: 150,000 เหรียญทอง",
        reward3: "อันดับ 3: 100,000 เหรียญทอง",
        reward4: "อันดับ 4: 50,000 เหรียญทอง",
        reward5: "อันดับ 5: 50,000 เหรียญทอง",
      },
      pointsCalculation: {
        description: "ยอดเกมขั้นต่ำ 5,000,000 ถึงมีสิทธิ์รับรางวัลกิจกรรม",
      },
      helpReward: {
        description:
          "รางวัลช่วย: ถ้าถึงเงื่อนไขแต่ไม่ได้รางวัลอันดับ จะได้รางวัลช่วยนี้",
      },
      turnoverRewards: {
        title: "กฎรางวัลยอด",
        turnover: "ยอด",
        reward: "รางวัล",
        turnover1M: "1 ล้าน",
        reward10K: "10,000 เหรียญทอง",
        turnover3M: "3 ล้าน",
        reward30K: "30,000 เหรียญทอง",
        turnover5M: "5 ล้าน",
        reward50K: "50,000 เหรียญทอง",
      },
      distribution: {
        title: "กฎการแจกรางวัล",
        description:
          "รางวัลตามอันดับรายวันจะแจกวันถัดไป ดูสถานะรับได้ในหน้ากิจกรรมหรือบัญชีวันถัดไป",
      },
      violation: {
        title: "กฎการละเมิดและบทลงโทษ",
        description:
          "ระหว่างกิจกรรม ห้ามใช้บั๊ก สคริปต์ หรือวิธีอื่นโกงคะแนน(เหรียญ) หากพบ:",
        penalty1: "5. ครั้งแรกจะตัดสิทธิ์รางวัลวันนั้น",
        penalty2:
          "6. ร้ายแรงหรือทำซ้ำจะถูกแบนจากกิจกรรมนี้และกิจกรรมที่เกี่ยวข้อง และไม่คืนสิทธิ์",
      },
    },
  },

  luckyAnchorRanking: {
    today: "วันนี้",
    yesterday: "เมื่อวาน",
    notRanked: "ไม่อยู่ในอันดับ",
    distanceToRank: "ห่าง Top 50 อีก {points} ถั่วโชคดี",
    distanceToBeforeRank: "ห่างอันดับ {rankId} อีก {points} ถั่วโชคดี",
    rank1: "คุณอยู่อันดับ 1 แล้ว",
    rules: {
      activity: {
        title: "คำอธิบายกิจกรรม",
        description: "นับรายได้ถั่วโชคดีรายวันของผู้ดำเนินรายการ แล้วจัดอันดับ",
      },
      ranking: {
        title: "รางวัลอันดับ",
        rank: "อันดับ",
        reward: "รางวัลถั่ว",
        decoration: "ของตกแต่ง",
        frameAndBubble: "กรอบอวาตาร์+ฟอง",
        frameOnly: "กรอบอวาตาร์",
        requirement: "เงื่อนไขขั้นต่ำรางวัลอันดับ: รายได้ถั่วโชคดี 150,000",
      },
      helpReward: {
        title: "รางวัลช่วย",
        description:
          "ผู้ที่ไม่ได้รางวัลอันดับ ก็ได้รางวัลตามเป้ารายได้ถั่วโชคดี",
        target: "เป้า",
        reward: "รางวัล",
      },
      distribution: {
        title: "การแจกรางวัล",
        description: "รางวัลจะแจกวันถัดไป",
      },
      statistics: {
        title: "คำอธิบายสถิติ",
        description: "สถิติคือรายได้ถั่วโชคดี",
      },
    },
  },

  redEnvelopeRain: {
    countdownTitle: "นับถอยหลังแย่งเหรียญ",
    startNow: "เริ่มเลย",
    rules: "กฎ",
    timeSlotPrize: "รางวัลช่วงเวลา",
    winningDetails: "รายละเอียดถูกรางวัล",
    activityRules: "กฎกิจกรรม",
    congratulations: "ยินดีด้วยที่ถูกรางวัล!",
    sorryNoWin: "เสียใจยังไม่ถูกรางวัล!",
    coin: "เหรียญ",
    rulesContent: {
      rule1: "1. ระยะกิจกรรม: 26 ก.ย. – 15 ต.ค.",
      rule2: "2. ก่อนเปิดซองแต่ละครั้ง พูดในห้องลีฟ 3 ข้อความ จึงรับซองได้",
      rule3: "3. ทุกวัน 20:00–00:40 รับซองได้ทุก 20 นาที",
      rule4: "4. ช่วงเวลาต่างกันเข้าร่วมซ้ำได้",
      rule5: "5. เหรียญที่รับจะเข้าบัญชีแบบเรียลไทม์",
    },
    timeStatus: {
      inProgress: "กำลังดำเนินการ",
      notStarted: "ยังไม่เริ่ม",
      finished: "จับรางวัลแล้ว",
    },
    chatRequirement: "พูดในห้องลีฟ 3 ข้อความถึงรับได้ ปัจจุบัน {count} ข้อความ",
  },

  guildActivity: {
    ruleBtn: "Rule",
    tabThis: "THIS",
    tabLast: "LAST",
    activityRules: "กฎกิจกรรม",
    rulesContent: {
      activityTime: "ระยะกิจกรรม: เริ่ม 29 ก.ย.",
      rankingRewards: "รางวัลอันดับ",
      requirements: "เงื่อนไข",
      rewardDistribution: "การแจกรางวัล",
      rewardList: {
        first: "อันดับ 1: 1,000,000 ถั่วทอง",
        second: "อันดับ 2: 500,000 ถั่วทอง",
        thirdToFifth: "อันดับ 3–5: 250,000 ถั่วทอง",
        sixthToTenth: "อันดับ 6–10: 100,000 ถั่วทอง",
        eleventhToTwentieth: "อันดับ 11–20: 50,000 ถั่วทอง",
      },
      requirementText:
        "ผู้ดำเนินรายการกิลด์ต้องออกอากาศอย่างน้อย 30 ครั้ง/สัปดาห์ แต่ละคนออกเกิน 2 ชม./วัน นับ 1 ครั้ง",
      distributionText: "รางวัลแจกสัปดาห์ที่สอง",
    },
  },

  charmRanking: {
    charmRanking: "อันดับความนิยม",
    consumptionRanking: "อันดับการใช้จ่าย",
    dailyRanking: "อันดับรายวัน",
    weeklyRanking: "อันดับรายสัปดาห์",
    userNickname: "ชื่อผู้ใช้",
    distanceToPrevious: "ห่างอันดับก่อน",
    noRankingData: "ไม่มีข้อมูลอันดับ",
    requestFailed: "คำขอล้มเหลว",
  },

  inviteActivity: {
    title: "เชิญ 3 คนรับรางวัล",
    rule: "กฎ",
    alreadyJoined: "เข้าร่วมแล้ว",
    inviteImmediately: "เชิญเลย",
    callNumber: "เชิญ",
    myRewards: "รางวัลของฉัน",
    claim: "รับ",
    claimed: "รับแล้ว",
    people: "คน",
    inviteFriends: "เชิญเพื่อน",
    processTitle: "ขั้นตอนการเชิญ:",
    step1: "1. ส่งลิงก์ให้เพื่อน",
    step2: "2. เพื่อนดาวน์โหลดและลงทะเบียน",
    step3: "3. ได้เหรียญฟรี",
    rulesTitle: "กฎการเชิญ",
    rulesContent: {
      rule1: "เชิญครบ 3 คน รับ 16666 ถั่วทอง",
      rule2: "เชิญครบ 25 คน รับอีก 36666 ถั่วทอง",
      rule3: "เชิญครบ 100 คน รับอีก 88888 ถั่วทอง รวมรับได้ 142220 ถั่วทอง",
      rule4: "รับรางวัลด้วยตนเองในหน้ากิจกรรม",
      rule5: "ห้ามโกงจำนวนการเชิญ หากพบจะแบนบัญชี",
    },
    close: "ปิด",
    inviteFeatureComingSoon: "ฟีเจอร์เชิญเร็วๆ นี้",
    rewardReceived: "รับ {amount} เหรียญสำเร็จ!",
  },

  giftGoldCoins: {
    maxGiftableCoins: "เหรียญที่ให้ได้สูงสุด",
    giftAmount: "จำนวนเหรียญที่ให้",
    customAmount: "กำหนดจำนวนเหรียญที่ให้",
    enterAmount: "กรอกจำนวน",
    quantity: "จำนวน",
    giftToOtherAccounts: "ให้บัญชีอื่น",
    exceedMaxAmount: "จำนวนเกินที่ให้ได้สูงสุด",
    amountSet: "ตั้งจำนวนสำเร็จ",
    invalidAmount: "กรุณากรอกจำนวนที่ถูกต้อง",
    selectValidAmount: "กรุณาเลือกจำนวนที่ถูกต้อง",
    confirmTitle: "ยืนยันการให้",
    confirmMessage: "ยืนยันให้ {amount} เหรียญใช่ไหม?",
    giftSuccess: "ให้สำเร็จ",
    giftId: "รหัสผู้รับ",
    enterGiftId: "กรุณากรอกรหัส",
    pleaseEnterGiftId: "กรุณากรอกรหัสผู้รับ",
    giftCompleted: "ให้เสร็จแล้ว!",
    giftedToId: "ให้ถึงรหัส",
    networkError: "เครือข่ายผิดพลาด กรุณาลองใหม่",
    confirm: "ยืนยัน",
  },

  shop: {
    headerTitle: "ของตกแต่งส่วนตัว",
    back: "กลับ",
    shoppingBag: "กระเป๋าช็อปปิ้ง",
    loading: "กำลังโหลด...",
    noProducts: "ไม่มีสินค้า",
    unnamedProduct: "สินค้าไม่มีชื่อ",
    day: "วัน",
    myCoins: "เหรียญของฉัน",
    exchangeNow: "แลกเลย",
    notSelected: "ยังไม่เลือก",
    loginExpired: "เข้าสู่ระบบหมดอายุ กรุณาเข้าสู่ระบบใหม่",
    categoryNotExists: "ไม่มีหมวดนี้",
    loadFailed: "โหลดล้มเหลว",
    loadFailedRetry: "โหลดล้มเหลว กรุณาลองใหม่",
    pleaseSelectProduct: "กรุณาเลือกสินค้าก่อน",
    productNotExists: "ไม่มีสินค้านี้",
    insufficientCoins: "เหรียญไม่พอ ต้องการ {amount} เหรียญ",
    exchangeSuccess: "แลกสำเร็จ",
    exchangeFailed: "แลกล้มเหลว",
    categories: {
      hot: "ยอดนิยม",
      avatarFrame: "กรอบอวาตาร์",
      entryEffect: "เอฟเฟกต์เข้า",
      chatBubble: "ฟองแชท",
      mount: "ยาน",
    },
    recharge: "เติมเงิน >",
    validityPeriod: "อายุ:",
    myCoinsLabel: "เหรียญของฉัน:",
  },

  myDecoration: {
    headerTitle: "ของตกแต่งของฉัน",
    back: "กลับ",
    noWearingDecoration: "ยังไม่มีของตกแต่งที่สวม",
    loading: "กำลังโหลด...",
    noDecoration: "ไม่มีของตกแต่ง",
    unnamedDecoration: "ของตกแต่งไม่มีชื่อ",
    permanent: "ถาวร",
    wearing: "กำลังสวม",
    pleaseSelectDecoration: "กรุณาเลือกของตกแต่ง",
    removeDecoration: "ถอดของตกแต่ง",
    wearNow: "สวมเลย",
    pleaseSelectDecorationFirst: "กรุณาเลือกของตกแต่งก่อน",
    decorationNotExists: "ไม่มีของตกแต่งนี้",
    loginExpired: "เข้าสู่ระบบหมดอายุ กรุณาเข้าสู่ระบบใหม่",
    loadFailed: "โหลดล้มเหลว",
    loadFailedRetry: "โหลดล้มเหลว กรุณาลองใหม่",
    wearSuccess: "สวมสำเร็จ",
    wearFailed: "สวมล้มเหลว",
    previewAnimation: "ดูตัวอย่าง",
    categories: {
      hot: "ยอดนิยม",
      avatarFrame: "กรอบอวาตาร์",
      entryEffect: "เอฟเฟกต์เข้า",
      chatBubble: "ฟองแชท",
      mount: "ยาน",
    },
  },

  christmasActivity: {
    dailyLuckyStar: "ดวงโชคลาภรายวัน",
    weeklyLuckyStar: "ดวงโชคลาภรายสัปดาห์",
    startTime: "เวลาเริ่ม:",
    obtainedCount: "จำนวนที่ได้",
    moreChance: "ยิ่งมาก โอกาสยิ่งมาก",
    participated: "เข้าร่วมแล้ว",
    notParticipated: "ยังไม่เข้าร่วม",
    historyRecord: "ประวัติ",
    myRecord: "บันทึกของฉัน",
    noRecord: "ไม่มีบันทึก",
    loading: "กำลังโหลด...",
    noMore: "ไม่มีเพิ่มเติม",
    coin: "เหรียญ",
    goldCoin: "ถั่วทอง",
    unit: "ชิ้น",
    notWon: "ยังไม่ถูกรางวัล",
    conditionNotMet: "ยังไม่ถึงเงื่อนไข",
    claimSuccess: "รับสำเร็จ",
    getRecordFailed: "ดึงบันทึกล้มเหลว",
    rules: {
      title: "กฎกิจกรรม",
      rule1: "ดวงโชคลาภรายวัน",
      rule2: "กิจกรรมดวงโชคลาภรายวัน ผู้ใช้ทุกคนเข้าร่วมได้",
      rule3:
        "เมื่อส่งของขวัญที่กำหนดให้ผู้ดำเนินรายการ จะสะสมจำนวนของขวัญ ถึงจำนวนที่กำหนดจึงเข้าร่วมเปิดซองได้ แต่ละครั้งจะมีผู้โชคดีได้เหรียญ",
      rule4: "ส่งของขวัญยิ่งมาก โอกาสถูกรางวัลยิ่งสูง",
      rule5: "ดวงโชคลาภรายสัปดาห์",
      rule6: "กิจกรรมดวงโชคลาภรายสัปดาห์ ผู้ดำเนินรายการทุกคนเข้าร่วมได้",
      rule7:
        "เมื่อรับของขวัญที่กำหนดจากผู้ใช้ จะสะสมจำนวน ถึงจำนวนที่กำหนดจึงเข้าร่วมเปิดซองดวงโชคลาภรายสัปดาห์ได้ แต่ละครั้งจะมีผู้โชคดีได้รางวัล",
      rule8: "รับของขวัญยิ่งมาก โอกาสถูกรางวัลยิ่งสูง",
      rule9: "หมายเหตุอื่น",
      rule10: "กิจกรรมนี้เป็นโปรโมชันขอบคุณผู้ใช้",
      rule11: "สะสมได้เฉพาะเมื่อส่งของขวัญให้ผู้ดำเนินรายการอื่น",
      rule12: "ห้ามใช้บั๊กรับรางวัล",
      rule13: "รางวัลแต่ละช่วงจะแจกอัตโนมัติ ดูประวัติถูกรางวัลได้",
    },
  },

  fortuneStarActivity: {
    points: "คะแนน",
    pointsRanking: "อันดับคะแนน",
    currentRoundPoints: "คะแนนรอบนี้",
    lastRoundPoints: "คะแนนรอบก่อน",
    defaultUserName: "ชื่อผู้ใช้",
    noData: "ไม่มีข้อมูล",
    activityRules: "กฎ",
    historyRecord: "ประวัติ",
    earnedPoints: "คะแนนที่ได้",
    participated: "เข้าร่วมแล้ว",
    notParticipated: "ยังไม่ถึง",
    myRecord: "บันทึกของฉัน",
    userId: "ID",
    userNickname: "ชื่อผู้ใช้",
    sessionTime: "เวลารอบ",
    winningStatus: "สถานะรางวัล",
    won: "ถูกรางวัล",
    notWon: "ยังไม่ถูกรางวัล",
    rules: {
      rule1: "ระหว่างกิจกรรม ส่งของขวัญที่กำหนดเพื่อได้คะแนน",
      rule2: "คะแนนสะสมแบบเรียลไทม์ ดูอันดับปัจจุบันได้",
      rule3: "หลังจบกิจกรรม อันดับสูงจะได้รางวัล",
      rule4: "ห้ามโกงคะแนน ผู้ละเมิดจะถูกตัดสิทธิ์",
      rule5: "แพลตฟอร์มมีสิทธิ์ตีความสุดท้าย",
    },
  },

  blindBox: {
    title: "วิธีเล่น",
    ruleTitle: "วิธีเล่น",
    rule1:
      "ทุก {price} เหรียญทอง เปิด {text} ได้ 1 ครั้ง ส่งของขวัญแล้วจะได้ของขวัญแบบสุ่ม ส่งให้ผู้ดำเนินรายการที่กำหนดโดยอัตโนมัติ",
    rule2:
      "ผู้ส่ง {text} เมื่อของขวัญที่ออกส่งให้ผู้ดำเนินรายการแล้ว จะได้ถั่วทองตามที่กำหนด",
    rewardTip: "คำเตือนรางวัล",
    probabilityDesc: "ความน่าจะเป็นดังนี้:",
    prize: "รางวัล",
    probability: "ความน่าจะเป็น",
    value: "มูลค่า",
  },

  taskHub: {
    tabCenter: "Task Center",
    tabAnchor: "Host Tasks",
    signTitle: "7-day Check-in",
    signStreakBefore: "Consecutive check-in ",
    signStreakAfter: " days",
    signBtn: "Check in",
    signBtnDone: "Checked in",
    signPeriod: "This period: {start} - {end}",
    dayLabel: "Day{n}",
    avatarFrame: "Avatar frame",
    activeTasks: "User activity tasks",
    timeLeft: "Time left: {t}",
    claimable: "Claim",
    inProgress: "In progress",
    rewardGain: "Earn {n} EX coins",
    taskWatchLive: "Watch live for 30 minutes",
    taskFollowHosts: "Follow 3 hosts",
    taskSpeakRooms: "Speak 3 times in different rooms",
    taskGiftCoins: "Spend 100 coins on gifts",
    taskGameCoins: "Spend 100 coins on games",
    taskRechargeToday: "Recharge once today",
    unitMinutes: " min",
    unitHosts: " hosts",
    unitTimes: " times",
    unitCoins: " coins",
    unitDays: " days",
    toastSigned: "Checked in",
    toastClaimed: "Claimed",
    claimSuccessTitle: "Claim Successful",
    claimSuccessOk: "Got it",
    toastInProgress: "Task in progress",
    toastLoadFail: "Failed to load",
    claimed: "Completed",
    toastRefreshed: "Refreshed",
    anchorActivity: "Activity",
    weekDurationTitle: "Weekly duration",
    activityPeriod: "Activity period",
    weekLiveDuration: "Live duration this week",
    weekRank: "Weekly rank",
    claimableReward: "Claimable reward",
    effectExtraTitle: "Special effect bonus",
    effectBeansToday: "Effect beans received today",
    rewardDate: "Reward date {date}",
    claimableAmount: "Claimable",
    claimNow: "Claim now",
    claimedToday: "Claimed today:",
    effectNote: "Note: claim today's rewards before 1:00 (UTC+8) the next day.",
    todayData: "Today Data",
    todayLiveDuration: "Today's live duration",
    liveHintShort: "{remain} left",
    needMoreBeans: "{n} more needed",
    toastNoClaimable: "No reward available to claim",
    toastClaimPending: "Claim API pending integration",
    luckyBeans: "Lucky beans",
    nextDayLucky: "Next-day lucky reward",
    upgradeBeansTitle: "Upgrade to claim beans",
    upgradeReward: "Upgrade reward",
    weekData: "Week Data",
    totalLiveDuration: "Total live duration",
    validDays: "Valid days",
    weekLuckyReward: "Weekly lucky reward",
    dayDataTitle: "Today Data",
    monthDataTitle: "Month Data",
    weekDataTitle: "Week Data",
    monthLiveDuration: "Monthly live duration",
    weekLiveDuration: "Weekly live duration",
    specialBeans: "Special beans",
    totalBeans: "Total beans",
  },

  pcOfficial: {
    navHome: "หน้าแรก",
    navLive: "ไลฟ์สด",
    navGameHall: "ศูนย์เกม",
    received: "ได้รับ",
    heroTagline: "แพลตฟอร์มความบันเทิง Web4 ชั้นนำระดับโลก",
    heroTaglineSub:
      "โต้ตอบแบบเรียลไทม์ตลอด 24/7 กับโฮสต์ชั้นนำ และสัมผัสประสบการณ์เกมบล็อกเชนระดับพรีเมียม ขับเคลื่อนด้วยเทคโนโลยีกระจายศูนย์ เพื่อรางวัลทันทีและความยุติธรรม",
    downloadNow: "ดาวน์โหลดทันที",
    giftCoin: "เหรียญ EX",
    giftAvatarFrame: "กรอบอวาตาร์",
    bottomDownloadAndroidApk: "Android APK",
    recommendTitle: "แนะนำโฮสต์ยอดนิยม",
    recommendSub:
      "โต้ตอบแบบเรียลไทม์กับโฮสต์ชั้นนำหลายพันคน และสัมผัสเสน่ห์ของเกม P2E",
    hotGamingTitle: "เกมยอดนิยม",
    hotGamingSub: "ผู้เล่นจริง อันดับจริง คุณจะเป็นตำนานคนต่อไปหรือไม่?",
    casinoTitle: "Casino",
    casinoDesc1: "ร่วมเล่นกับดีลเลอร์สดในเกม Baccarat,",
    casinoDesc2: "Roulette และ Blackjack แบบ HD",
    slotsTitle: "Slots",
    slotsDesc: "สนุกกับสล็อตคุณภาพสูงมากมาย พร้อม RTP 98.5%",
    gamingTitle: "Gaming",
    gamingDesc: "มากกว่าแค่การหมุน สัมผัสเกมทักษะแบบหลายผู้เล่น",
    whyTitle: "ทำไมต้อง Rain Live",
    whyItem1Title: "ยุติธรรมและโปร่งใส",
    whyItem1Desc: "RNG ผ่านการตรวจสอบ รับรองความยุติธรรม",
    whyItem2Title: "จ่ายออกทันที",
    whyItem2Desc: "ถอนเร็ว เคลียร์ยอดทันที",
    whyItem3Title: "ไม่ระบุตัวตนและเป็นส่วนตัว",
    whyItem3Desc: "เป็นส่วนตัว 100% โดยไม่ต้องใช้ข้อมูลส่วนบุคคล",
    whyItem4Title: "กระจายศูนย์",
    whyItem4Desc: "เกมบนบล็อกเชนที่ปลอดภัยและโปร่งใส",
    terms: "ข้อกำหนดการให้บริการ",
    privacy: "นโยบายความเป็นส่วนตัว",
    navRecharge: "เติมเงิน",
    rechargeAccountTitle: "บัญชีเติมเงิน",
    idLogin: "เข้าสู่ระบบด้วย ID",
    accountIdLabel: "รหัสบัญชี:",
    accountIdPlaceholder: "กรอกรหัสบัญชี",
    confirm: "ยืนยัน",
    defaultUserName: "ชื่อผู้ใช้",
    userIdWithValue: "ID:{id}",
    switchAccount: "เปลี่ยนบัญชี",
    rechargeQuantityTitle: "จำนวนเติม",
    goToPay: "ไปชำระเงิน",
    topUpAmountTitle: "จำนวนเงินเติม",
    pay: "ชำระเงิน",
    channelDefault: "ช่องทางชำระเงิน",
    toastInvalidAccountId: "กรุณากรอกรหัสบัญชีที่ถูกต้อง",
    toastNoTokenAfterLogin: "เข้าสู่ระบบสำเร็จแต่ไม่ได้รับ token",
    toastLoginFailed: "เข้าสู่ระบบล้มเหลว",
    toastCoinPackagesFailed: "โหลดแพ็กเกจเหรียญไม่สำเร็จ",
    toastPayChannelsFailed: "โหลดช่องทางชำระเงินไม่สำเร็จ",
    toastOrderParamsMissing: "ข้อมูลคำสั่งซื้อไม่ครบ ไม่สามารถชำระเงินได้",
    toastNoPayUrl: "ไม่พบลิงก์ชำระเงิน",
    toastCreateOrderFailed: "สร้างคำสั่งชำระเงินไม่สำเร็จ",
    rainLiveRecharge: "Rain Live เติมเงิน",
    selectCountryTitle: "เลือกประเทศ / ภูมิภาค",
    selectChannelTitle: "เลือกช่องทางชำระเงิน",
    rechargeLoading: "กำลังโหลด...",
    rechargePackagesEmpty: "ไม่มีแพ็กเกจเติมเงิน",
    rechargeLoginHint: "กรุณาเข้าสู่ระบบด้วย ID ก่อน",
  },

  liveDuration: {
    tabthisWeek: "This  Week",
    tablastWeek: " Last Week",
    eventTime: "เวลากิจกรรม: {time}",
    rewardCoin: "เหรียญรางวัล",
    liveHours: "ระยะเวลาไลฟ์",
    myRank: "อันดับของฉัน",
    zeroHours: "0 ชม.",
    hoursOnly: "{hours} ชม.",
    minutesOnly: "{minutes} นาที",
    hoursMinutes: "{hours} ชม. {minutes} นาที",
  },

  // หน้าชำระเงินคำสั่งเติม USDT
  topUpUsdt: {
    orderNo: "หมายเลขคำสั่งซื้อ",
    copy: "คัดลอก",
    copyOrderNo: "คัดลอกหมายเลขคำสั่งซื้อ",
    copyAddress: "คัดลอกที่อยู่รับเงิน",
    productName: "เหรียญทอง RainChat",
    quantityUnit: "× {count}",
    orderAmount: "ยอดคำสั่งซื้อ",
    scanToPay: "สแกนเพื่อชำระเงิน",
    scanTip: "ใช้แอปกระเป๋าเงินสแกนคิวอาร์โค้ดเพื่อชำระเงิน",
    qrAreaAlt: "พื้นที่คิวอาร์โค้ดชำระเงิน",
    qrCodeAlt: "คิวอาร์โค้ดชำระเงิน",
    receivingAddress: "ที่อยู่รับเงิน",
    validityPrefix: "มีอายุ",
    validityMinutes: "{minutes} นาที",
    validitySuffix: " โปรดชำระโดยเร็ว",
    orderNoCopied: "คัดลอกหมายเลขคำสั่งซื้อแล้ว",
    addressCopied: "คัดลอกที่อยู่รับเงินแล้ว",
    nothingToCopy: "ไม่มีเนื้อหาให้คัดลอก",
    copyFailed: "คัดลอกล้มเหลว โปรดคัดลอกด้วยตนเอง",
    promptTitle: "แจ้งเตือน",
    rechargePrompt: "หากเติมเงินแล้ว โปรดแตะเติมเงินเสร็จสิ้น",
    cancel: "ยกเลิก",
    completeRecharge: "เติมเงินเสร็จสิ้น",
    rechargeCompleted: "✔ เติมเงินสำเร็จ",
    rechargeCompletedText: "เติมเงินสำเร็จ",
    rechargePending:
      "ขณะนี้ยังไม่พบยอดเข้า อาจมีความล่าช้า เหรียญจะถูกเพิ่มให้อัตโนมัติหลังยอดเข้า",
    gotIt: "เข้าใจแล้ว",
  },

  rainChatOfficial: {
    appNotDetected: "ไม่พบแอป โปรดดาวน์โหลด",
  },

  // กิจกรรมวงล้อนำโชคเหรียญประสบการณ์
  luckyTurntable: {
    draw: "สุ่มรางวัล",
    drawing: "กำลังสุ่ม",
    task: "ภารกิจ",
    recharge: "เติมเงิน",
    historyRecord: "ประวัติ",
    balanceLabel: "ยอดเหรียญประสบการณ์คงเหลือ: ",
    exGradeTip: "เลเวล Ex Lv.{grade} · ต้องการ Lv.{level} เพื่อเข้าร่วม",
    got: "ได้รับ",
    defaultNotice: "ชื่อผู้ใช้ {got} เหรียญประสบการณ์",
    insufficientBalance: "ยอดคงเหลือไม่เพียงพอ",
    exGradeNotMet: "เลเวล Ex ไม่ถึงเกณฑ์",
    configLoadFailed: "โหลดการตั้งค่าล้มเหลว กรุณาลองอีกครั้งในภายหลัง",
    recordLoadFailed: "โหลดประวัติล้มเหลว กรุณาลองอีกครั้งในภายหลัง",
    drawResultError: "ผลสุ่มรางวัลผิดปกติ กรุณาลองอีกครั้งในภายหลัง",
    drawFailed: "สุ่มรางวัลล้มเหลว กรุณาลองอีกครั้งในภายหลัง",
    winTitle: "ยินดีด้วย! คุณได้รับ",
    winConfirm: "เข้าใจแล้ว",
    loading: "กำลังโหลด...",
    noRecord: "ยังไม่มีประวัติ",
    noMore: "ไม่มีอีกแล้ว",
  },

  rewardActivity: {
    moreReward: "More",
    tabInvite: "เชิญที่แอคทีฟ",
    tabWelfare: "โบนัส 7 วัน",
    tabMic: "รางวัลขึ้นไมค์",
    inviteTitle: "รางวัลเชิญผู้ใช้ที่แอคทีฟ",
    yesterdayData: "ข้อมูลเมื่อวาน",
    yesterdayActive: "จำนวนแอคทีฟเมื่อวาน",
    goldBean: "ถั่วทอง",
    todayDataRealtime: "ข้อมูลวันนี้ (เรียลไทม์)",
    todayActive: "จำนวนแอคทีฟวันนี้",
    peopleUnit: "คน",
    estimateReward: "รางวัลโดยประมาณ",
    claimTomorrowTip: "รับได้ 10:00 ของวันถัดไป",
    claimAt10: "รับได้ตอน 10 โมง",
    claimYesterday: "รับรางวัลเมื่อวาน",
    claimed: "รับแล้ว",
    noReward: "ยังไม่มีรางวัล",
    viewDetail: "ดูรายละเอียด",
    welfareTitle: "โบนัส 7 วันโฮสต์ใหม่",
    personalNewHost: "โฮสต์ใหม่ส่วนตัว",
    rule: "กฎ",
    welfareRemain: "เวลาโบนัสที่เหลือ",
    dayUnit: "วัน",
    minuteUnit: "นาที",
    day1: "วันที่ 1",
    day7: "วันที่ 7",
    todayData: "ข้อมูลวันนี้",
    todayMicDuration: "เวลาขึ้นไมค์วันนี้",
    claimableBean: "ถั่วทองที่รับได้",
    claimReward: "รับรางวัล",
    claimTodayReward: "รับรางวัลวันนี้",
    todayCanClaim: "วันนี้ยังรับได้อีก {amount}",
    needMic60: "ขึ้นไมค์ 60 นาทีวันนี้จึงรับได้",
    needMic120: "ขึ้นไมค์ 120 นาทีวันนี้จึงรับได้",
    todayClaimedAll: "รับรางวัลวันนี้ครบแล้ว",
    becomeAnchor: "เป็นโฮสต์เพื่อรับรางวัล",
    totalClaimed: "ถั่วทองที่รับทั้งหมด",
    welfareRulesTitle: "7-Day Benefit Rules",
    welfareCondTitle: "1. Participation Requirements:",
    welfareCond1: "a. New users within 7 days of registration",
    welfareCond2: "b. Completed Host verification",
    welfareCond3: "c. Not joined any Agency",
    welfareRewardTitle: "2. Reward Details",
    welfareReward1:
      "a. Going on-mic and unmuting daily accumulates your on-mic time.",
    welfareReward2: "b. For every 1 hour, you can claim 5,000 Gold Beans.",
    welfareReward3:
      "c. You can claim up to 2 hours and 10,000 Gold Beans per day.",
    welfareReward4: "d. You can claim up to 70,000 Gold Beans in total.",
    welfareNoteTitle: "3. Notes",
    welfareNote1: "a. Rewards must be claimed manually every day",
    welfareNote2:
      "b. If you have been registered for more than 7 days, you can no longer claim.",
    welfareNote3: "c. Data is updated every 10-15 minutes",
    welfareNote4:
      "d. If unfair methods are found to be used to farm rewards, the account will be banned.",
    micRulesTitle: "On-Mic Reward Rules",
    micCondTitle: "1. Participation Requirements:",
    micCond1: "a. Completed Host verification",
    micCond2: "b. Not joined any Agency.",
    micRewardTitle: "2. Rewards",
    micGradeLevel: "Level",
    micGradeIncome: "7-Day Gold Bean Earnings",
    micGradeHourly: "Hourly Rate (Gold Beans/h)",
    micGradeDaily: "Daily Limit",
    micGradeBeans: "{beans} Gold Beans ({usd})",
    micGradeDailyLimit: "2 hours",
    micExplainTitle: "3. Explanation",
    micExplain1:
      "a. RainChat will calculate your level based on your Gold Bean earnings over the last 7 days (current day + previous 6 days)",
    micExplain2: "b. Data is updated every 10-15 minutes.",
    micExplain3:
      "c. Based on your current level, you can claim the hourly Gold Bean reward corresponding to that level.",
    micExplain4:
      "d. Rewards are claimed manually and will be credited to your account in real time after claiming.",
    micExplain5:
      "e. If you do not claim the reward on the same day, it will expire.",
    micExplain6: "f. You can claim up to 2 hours of hourly reward per day.",
    micExplain7:
      "g. When your 7-day Gold Bean earnings exceed the SS cap, for every additional 700,000 Gold Beans, the hourly rate increases by 20,000.",
    micExplainExample: "Example: 7,700,000 Gold Beans, hourly rate of 220,000.",
    micExplain8:
      'h. While enjoying the "7-Day Benefit", the "Level I" hourly reward is unavailable. After the "7-Day Benefit" ends, you can claim it normally.',
    micExplain9:
      "i. If unfair methods are found to be used to farm rewards, the account will be banned.",
    nextRefresh: "รีเฟรชครั้งถัดไป",
    recent7Days: "7 วันล่าสุด",
    micRangeTip: "วันนี้ + 6 วันก่อนหน้า\nต้องเป็นโฮสต์",
    totalIncome: "รายได้รวม",
    upgradeDesc: "อีก {remain} จะอัปเกรด โบนัสเพิ่ม {bonus}",
    ssBonusDesc: "ทุก ๆ 700K Gold Beans ที่เพิ่มขึ้น โบนัสจะเพิ่ม 20K Gold Beans",
    completeAllTask: "ทำภารกิจครบจะได้รับ",
    claim: "รับ",
    grantSuccess: "ส่งรางวัลสำเร็จ",
    thisTimeGot: "ครั้งนี้ได้รับ",
    grantedToAccount: "รางวัลเข้าบัญชีของคุณแล้ว",
    gotIt: "เข้าใจแล้ว",
    claimFail: "รับไม่สำเร็จ กรุณาลองใหม่ภายหลัง",
    micTaskName: "ไลฟ์/ขึ้นไมค์ {minutes} นาทีวันนี้",
  },
  guildApply: {
    "title": "สมัครเข้ากิลด์",
    "pendingCount": "{count} รออนุมัติ",
    "autoApproveTip": "เกิน 7 วันยอมรับอัตโนมัติ ตรวจด่วน",
    "joinRequest": "({rainId}) ต้องการเข้ากิลด์",
    "daysRemaining": "เหลือ {days} วัน",
    "appliedWithinOneDay": "สมัครภายใน 1 วัน",
    "appliedDaysAgo": "{days} วันก่อน",
    "boundDays": "ผูกพัน: {days} วัน",
    "incomeTier": "ระดับรายได้: {level}",
    "applyToGuild": "สมัครเข้ากิลด์",
    "reject": "ปฏิเสธ",
    "approve": "อนุมัติ",
    "noPendingRequests": "ไม่มีคำขอที่รอ",
    "approved": "อนุมัติแล้ว",
    "rejected": "ปฏิเสธแล้ว",
    "approvalConfirmTitle": "แจ้งเตือน",
    "approvalConfirmMessage": "หลังอนุมัติ ผู้ใช้จะเข้าร่วมกิลด์อื่น และจะไม่สร้างรายได้คอมมิชชันให้คุณอีกต่อไป",
    "back": "ย้อนกลับ",
    "pendingList": "คำขอที่รออยู่",
    "noToken": "ไม่พบโทเคนเข้าสู่ระบบ",
    "listLoadFailed": "โหลดรายการคำขอไม่สำเร็จ",
    "listLoadFailedRetry": "โหลดรายการคำขอไม่สำเร็จ ลองใหม่ภายหลัง",
    "operationFailedRetry": "ดำเนินการไม่สำเร็จ ลองใหม่ภายหลัง"
  },
  inviteFriendsNew: {
    "inviteRanking": "อันดับเชิญ",
    "messages": "ข้อความ",
    "totalRewards": "รวมรางวัลเชิญ",
    "earnings": "รายได้",
    "totalValue": "มูลค่ารวม",
    "viewDetails": "ดูรายละเอียด",
    "inviteStats": "สถิติเชิญ",
    "totalInvites": "รวม",
    "todayInvites": "วันนี้",
    "details": "รายละเอียด",
    "inviteFriends": "เชิญเพื่อน",
    "copyLink": "คัดลอกลิงก์",
    "close": "ปิด",
    "saveImage": "บันทึกรูป",
    "inviteModal": "หน้าต่างเชิญเพื่อน",
    "rightTools": "ทางเข้าหน้าอื่น",
    "noToken": "ไม่พบโทเคนเข้าสู่ระบบ",
    "rewardsLoadFailed": "โหลดรายได้เชิญไม่สำเร็จ",
    "rewardsLoadFailedRetry": "โหลดรายได้เชิญไม่สำเร็จ ลองใหม่ภายหลัง",
    "inviteInfoLoadFailed": "โหลดข้อมูลเชิญไม่สำเร็จ",
    "inviteInfoLoadFailedRetry": "โหลดข้อมูลเชิญไม่สำเร็จ ลองใหม่ภายหลัง",
    "linkNotReady": "ลิงก์เชิญยังไม่พร้อม",
    "linkCopied": "คัดลอกลิงก์เชิญแล้ว",
    "copyFailedRetry": "คัดลอกไม่สำเร็จ ลองใหม่ภายหลัง",
    "saveFailedRetry": "บันทึกรูปไม่สำเร็จ ลองใหม่ภายหลัง"
  },
  inviteRanking: {
    "title": "อันดับ",
    "earningsRank": "อันดับรายได้",
    "inviteRank": "อันดับเชิญ",
    "day": "วัน",
    "week": "สัปดาห์",
    "total": "รวม",
    "people": "คน",
    "noToken": "ไม่พบโทเคนเข้าสู่ระบบ",
    "loadFailed": "โหลดอันดับไม่สำเร็จ",
    "loadFailedRetry": "โหลดอันดับไม่สำเร็จ ลองใหม่ภายหลัง"
  },
  inviterInformation: {
    "title": "คำเชิญของฉัน",
    "earnings": "รายได้",
    "members": "สมาชิก",
    "filter": "กรอง:",
    "earningsTrend": "แนวโน้มรายได้",
    "dailyInvites": "เชิญรายวัน",
    "verifiedHost": "ดีเจที่ยืนยัน",
    "inGuild": "เข้ากิลด์แล้ว",
    "contact": "ติดต่อ",
    "level1Earnings": "รายได้เลเวล 1",
    "level2Earnings": "รายได้เลเวล 2",
    "totalUsd": "รวม (USD)",
    "loading": "กำลังโหลด...",
    "noMore": "ไม่มีแล้ว",
    "noData": "ไม่มีข้อมูล",
    "back": "ย้อนกลับ",
    "tabTypes": "ประเภทข้อมูลผู้เชิญ",
    "dateFilter": "กรองวันที่",
    "noToken": "ไม่พบโทเคนเข้าสู่ระบบ",
    "trendLoadFailed": "โหลดข้อมูลแนวโน้มไม่สำเร็จ",
    "trendLoadFailedRetry": "โหลดข้อมูลแนวโน้มไม่สำเร็จ ลองใหม่ภายหลัง",
    "listLoadFailed": "โหลดรายชื่อผู้เชิญไม่สำเร็จ",
    "listLoadFailedRetry": "โหลดรายชื่อผู้เชิญไม่สำเร็จ ลองใหม่ภายหลัง"
  },
  rewardSource: {
    "title": "รายละเอียดรางวัล",
    "pleaseSelect": "เลือก",
    "activityEarnings": "แอคทีฟ",
    "rechargeEarnings": "เติมเงิน",
    "gameCommission": "เกม",
    "incomeCommission": "รายได้",
    "back": "ย้อนกลับ"
  },
  rewardSourceDetail: {
    "title": "รายละเอียดแหล่งรางวัล",
    "rules": "กฎ",
    "activityEarnings": "แอคทีฟ",
    "rechargeEarnings": "เติมเงิน",
    "gameCommission": "เกม",
    "incomeCommission": "รายได้",
    "totalEarnings": "รวม",
    "yesterdayEarnings": "เมื่อวาน",
    "todayEstimate": "วันนี้",
    "todayActiveUsers": "ผู้ใช้แอคทีฟ",
    "currentRankReward": "รางวัลปัจจุบัน",
    "upgradeReward": "เพิ่ม {count} คนแอคทีฟเพื่ออัปเกรดเป็น {reward}",
    "maxRewardTier": "ถึงระดับรางวัลสูงสุดแล้ว",
    "teamRevenue": "ยอดทีม 30 วัน",
    "currentCommission": "คอมมิชชันปัจจุบัน",
    "upgradeCommission": "ต้องมียอด {flow} เพื่อถึง {rate}",
    "maxCommissionTier": "ถึงระดับคอมมิชชันสูงสุดแล้ว",
    "invitedUsers": "ผู้ใช้ที่เชิญ 7 วัน",
    "all": "All",
    "active": "Active",
    "inactive": "Inactive",
    "certified": "ยืนยันแล้ว",
    "agency": "Agency",
    "micTime": "เวลาขึ้นไมค์",
    "minutes": "นาที",
    "gameRevenue": "ยอดเกม",
    "coins": "เหรียญ",
    "loading": "กำลังโหลด...",
    "noMore": "ไม่มีแล้ว",
    "noData": "ไม่มีข้อมูล",
    "total": "รวมทั้งหมด",
    "last7Days": "7 วันล่าสุด",
    "yesterday": "เมื่อวาน",
    "today": "วันนี้",
    "level1Commission": "คอมมิชชันเลเวล 1",
    "level2Commission": "คอมมิชชันเลเวล 2",
    "totalIncome": "รายได้รวม",
    "commissionRate": "อัตราคอมมิชชัน",
    "upgradeGap": "ห่าง {amount} ถึงอัปเกรด",
    "activeHelpUpdate": "อัปเดตข้อมูลภายใน 10-15 นาที",
    "activeHelpReward": "รับรางวัลที่หน้าหลัก-รางวัล เวลา 10.00 ของวันรุ่งขึ้น",
    "rechargeHelpUpdate": "อัปเดตข้อมูลภายใน 10-15 นาที",
    "rechargeHelpReward": "รางวัลเข้าบัญชีทันทีหลังจากผู้ใช้เติมเงิน",
    "gameHelpUpdate": "อัปเดตข้อมูลภายใน 10-15 นาที",
    "gameHelpReward": "ระบบจ่ายรางวัลในวันรุ่งขึ้น",
    "roomHelpUpdate": "อัปเดตข้อมูลภายใน 10-15 นาที",
    "roomHelpCommission": "รวมถึง คอมมิชชันของคุณ สมาชิกเลเวล1 และเลเวล2",
    "roomHelpReward": "ระบบจ่ายรางวัลในวันรุ่งขึ้น",
    "back": "ย้อนกลับ",
    "viewHelp": "ดูคำอธิบาย",
    "todayEstimateHelp": "คำอธิบายประมาณการวันนี้"
  },
};
